export default __webpack_public_path__ + "static/media/icons8-treeremoval.3db313c4.svg";